import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  TextField,
  Alert,
} from "@mui/material";
import "./styles.css";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { ThemeContext } from "@emotion/react";
import img_lat from "../resources/imgs/loginimg.png";
import { useDispatch } from "react-redux";
import { AUTH_LOGIN, AUTH_LOGOUT } from "../../redux/reducers/auth.reducer";
import { UseLogin } from "../../hooks/login";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../components/Loading/useLoading";
import { REACT_APP_ENVIRONMENT } from "../../env";
import { PasswordModal } from "./password/passwordModal";
import { FindSystemConfiguration } from "../../hooks/systemConfiguration";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { mutateLogin } = UseLogin();
  const { findSystemConfigurationMutation } = FindSystemConfiguration();
  const { setAppLoading } = useLoading();
  const theme = useContext(ThemeContext);

  setAppLoading(false);
  const [alerta, setAlerta] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [expiredPass, setExpiredPass] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const validatePasswordDate = (limitDays, fecha) => {
    if (!fecha) return false;

    const inputDate = new Date(fecha);
    const today = new Date();

    // Resetear horas, minutos y segundos para comparar solo fechas puras
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    // Diferencia en milisegundos
    const diffInMs = today.getTime() - inputDate.getTime();

    // Convertir milisegundos a días
    // 1 día = 24h * 60m * 60s * 1000ms = 86,400,000
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    // Si la diferencia es menor al límite, regresa true
    return diffInDays < limitDays;
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handlePasswordOnTime = (user) => {
    setAppLoading(true);
    findSystemConfigurationMutation(1, {
      onSuccess: (data) => {
        let isValid = validatePasswordDate(
          +data?.value,
          user?.passwordValidatedOn,
        );
        if (isValid) {
          setAlerta(false);
          navigate(`/home`);
        } else {
          AUTH_LOGOUT()
          setExpiredPass(true);
          setOpenPassword(true);
        }
      },
      onError: (error) => {
        console.log(error);
      },
      onSettled: () => {
        setAppLoading(false);
      },
    });
  };
  const handleSubmit = (event) => {
    setAppLoading(true);
    setExpiredPass(false);
    event.preventDefault();
    mutateLogin(
      {
        username: event.target.username.value,
        password: event.target.password.value,
      },
      {
        onSuccess: (data) => {
          if (data) {
            dispatch(
              AUTH_LOGIN({
                user: data,
                token: data.access_token,
                permissions: data.permissions,
              }),
            );
            setTimeout(() => {
              handlePasswordOnTime(data);
            }, 500);
          } else {
            setAlerta(true);
          }
        },
        onError: (error) => {
          console.log(error);
          setAlerta(true);
        },
        onSettled: () => {
          setAppLoading(false);
        }
      },
    );
  };

  return (
    <>
      {REACT_APP_ENVIRONMENT !== "production" && (
        <Grid
          key="container_development_tag"
          container
          spacing={0}
          sx={{
            backgroundColor: "#FE0000",
          }}
        >
          <Grid item xs={12} sx={{ p: 1 }}>
            <span
              key="development_tag"
              style={{
                color: "white",
                fontWeight: 700,
                fontSize: 20,
              }}
            >
              Entorno de Desarrollo
            </span>
          </Grid>
        </Grid>
      )}
      <Container
        sx={{
          paddingTop: 10,
          paddingLeft: "80px !important",
          paddingRight: "80px !important",
        }}
      >
        <Paper elevation={5} square>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              sx={{ padding: "60px 0" }}
            >
              <Grid container>
                <form
                  style={{ width: "100%", padding: "0 15%" }}
                  onSubmit={handleSubmit}
                >
                  <Grid
                    item
                    xs={12}
                    className="center_item"
                    sx={{ marginBottom: 5 }}
                  >
                    <span
                      style={{ color: theme.palette.primary.title }}
                      className="title_lg"
                    >
                      Login
                    </span>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    className="center_item"
                    sx={{ marginBottom: 5 }}
                  >
                    <TextField
                      required
                      id="username"
                      label="Usuario"
                      fullWidth
                      sx={{ color: theme.palette.primary.input }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    className="center_item"
                    sx={{ marginBottom: 2 }}
                  >
                    <FormControl sx={{ width: "100%" }} variant="outlined">
                      <InputLabel htmlFor="password">Contraseña</InputLabel>
                      <OutlinedInput
                        id="password"
                        type={showPassword ? "text" : "password"}
                        required
                        sx={{ color: theme.palette.primary.input }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Password"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} className="center_item" sx={{ mb: 2 }}>
                    <Button
                      variant="text"
                      className="btn_lg"
                      type="button"
                      onClick={() => setOpenPassword(true)}
                    >
                      Recuperar contraseña
                    </Button>
                  </Grid>
                  <Grid item xs={12} className="center_item">
                    <Button
                      variant="contained"
                      className="btn_lg"
                      type="submit"
                    >
                      Log In
                    </Button>
                  </Grid>
                </form>
              </Grid>
              {alerta && (
                <div
                  style={{ paddingLeft: 20, paddingRight: 20, marginTop: 20 }}
                >
                  <Alert
                    severity="error"
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    Error al iniciar sesión
                  </Alert>
                </div>
              )}
            </Grid>
            <Grid
              item
              xs={0}
              sm={0}
              md={6}
              lg={6}
              xl={6}
              sx={{ backgroundImage: `url(${img_lat})` }}
            >
              <Box className="img_login"></Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>
      <PasswordModal
        key="passwordRecover"
        open={openPassword}
        setOpen={setOpenPassword}
        expiredPass={expiredPass}
        setExpiredPass={setExpiredPass}
      />
    </>
  );
};

export default Login;
